import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './PrivacyScreen.module.css';

const OWNER = 'רומי פרץ';
const EMAIL = 'Romiperetz88@gmail.com';
const PHONE = '050-464-7878';

function PrivacyScreen() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.bgOrb1} />
      <div className={styles.bgOrb2} />

      <div className={styles.container}>
        <Link to="/" className={styles.backLink}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={styles.backIcon}>
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
          חזרה לאתר
        </Link>

        <header className={styles.header}>
          <h1 className={styles.title}>תקנון ומדיניות פרטיות</h1>
          <p className={styles.subtitle}>{OWNER}</p>
          <p className={styles.updateDate}>עודכן לאחרונה: אוגוסט 2025</p>
        </header>

        <div className={styles.card}>
          <div className={styles.contactBar}>
            <span>דוא"ל: {EMAIL}</span>
            <span>טלפון: {PHONE}</span>
          </div>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>1. מבוא</h2>
            <p>ברוך הבא לאתר של {OWNER} ("האתר"). השימוש באתר, בתכניו ובשירותיו כפוף לתנאים המפורטים במסמך זה ("התקנון"), ומהווה את הסכמתך לכל תנאיו. אם אינך מסכים לאחד או יותר מהתנאים - אנא הימנע משימוש באתר.</p>
            <p>האתר משמש כפלטפורמה להצגת שירותים, תוכן מקצועי, מידע שיווקי וכלים מקוונים בתחומי פעילותו של {OWNER}.</p>
            <p>התקנון נוסח בלשון זכר מטעמי נוחות בלבד אך מיועד לשני המינים.</p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>2. שימוש מותר באתר</h2>
            <p>השימוש באתר מיועד למטרות פרטיות בלבד, ואינו מקנה לך זכות להעתיק, לשכפל, לשנות, להפיץ או לפרסם תכנים מהאתר ללא אישור בכתב ומראש מבעל האתר.</p>
            <p>חל איסור לעשות שימוש באתר או בשירותיו לכל מטרה בלתי חוקית, לרבות פגיעה בפרטיות, חדירה למערכות, הפצת דואר זבל או ניסיון להונות.</p>
            <p>אין לקשר לאתר מאתרים בעלי תכנים פוגעניים, פורנוגרפיים, מפלים או המעודדים פעילות בלתי חוקית.</p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>3. הרשאה לדיוור ושיווק</h2>
            <p>מסירת פרטים באתר מהווה הסכמה לקבלת תוכן שיווקי, עדכונים והצעות פרסום בהתאם לחוק התקשורת (בזק ושידורים), תשמ"ב-1982, תיקון 40.</p>
            <p>ניתן להסיר עצמך בכל עת מרשימת התפוצה באמצעות הקישור המופיע בדיוור או בפנייה ישירה לבעל האתר.</p>
            <p>חל איסור למסור באתר פרטים של אדם אחר ללא הסכמתו המפורשת.</p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>4. איסוף מידע ושימוש בו</h2>
            <p>האתר פועל בהתאם לחוק הגנת הפרטיות, התשמ"א-1981, ותקנות הגנת הפרטיות (אבטחת מידע), לרבות תיקון 13 (2024).</p>

            <h3 className={styles.subTitle}>4.1 סוגי המידע הנאספים:</h3>
            <ul className={styles.list}>
              <li>מידע שאתה מוסר ישירות: שם, פרטי קשר, תוכן פנייה, פרטי שירותים שהתעניינת בהם.</li>
              <li>מידע הנאסף אוטומטית: כתובת IP, סוג דפדפן, מערכת הפעלה, מיקומי גלישה, נתוני שימוש באתר, Cookies.</li>
            </ul>

            <h3 className={styles.subTitle}>4.2 מטרות השימוש במידע:</h3>
            <ul className={styles.list}>
              <li>אספקת השירותים שביקשת.</li>
              <li>התאמת חוויית הגלישה.</li>
              <li>שיווק, פרסום והצעות מותאמות אישית.</li>
              <li>ניתוח סטטיסטי ושיפור השירותים.</li>
              <li>עמידה בהוראות הדין.</li>
            </ul>

            <h3 className={styles.subTitle}>4.3 זכויותיך:</h3>
            <ul className={styles.list}>
              <li>עיון במידע שנאסף.</li>
              <li>תיקון או מחיקה.</li>
              <li>התנגדות לשיווק.</li>
            </ul>
            <p>לפניות: {EMAIL}</p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>5. Cookies וטכנולוגיות מעקב</h2>
            <p>האתר משתמש ב-Cookies וכלים אנליטיים (Google Analytics) לצורך תפעול, שיפור והתאמת חוויית המשתמש.</p>
            <p>ניתן לחסום אותם דרך הדפדפן, אך זה עלול לפגוע בחוויית השימוש.</p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>6. אחריות והגבלת אחריות</h2>
            <p>התכנים באתר ניתנים כמות שהם (AS IS). אין התחייבות להתאמה מלאה לצרכים שלך.</p>
            <p>בעל האתר אינו אחראי לנזק ישיר או עקיף עקב הסתמכות על התוכן.</p>
            <p>שירותים מקצועיים אינם תחליף לייעוץ אישי מותאם.</p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>7. קניין רוחני</h2>
            <p>כל הזכויות בתכנים, קוד, מדיה, לוגו ועיצובים שמורות ל{OWNER}, אלא אם צוין אחרת.</p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>8. אבטחת מידע</h2>
            <p>האתר מיישם אמצעי הגנה מתקדמים לפי חוק. במקרה של פריצה, תינתן הודעה לרשות להגנת הפרטיות ולמשתמשים הרלוונטיים.</p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>9. שינויים במדיניות</h2>
            <p>האתר רשאי לעדכן את התקנון ומדיניות הפרטיות. שימוש באתר מהווה הסכמה לתנאים המעודכנים.</p>
          </section>

          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>10. יצירת קשר</h2>
            <p>לשאלות, פניות או בקשות:</p>
            <div className={styles.contactInfo}>
              <p>{OWNER}</p>
              <p>{EMAIL}</p>
              <p>{PHONE}</p>
            </div>
          </section>
        </div>

        <div className={styles.bottomBar}>
          <Link to="/" className={styles.backBtn}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={styles.backIcon}>
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
            חזרה לעמוד הראשי
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyScreen;
